export enum Role {
    User = "G$USER",
    SuperAdmin = "G$SUPPER_ADMIN",
    SystemAdmin = "G$SYSTEM_ADMIN",
    Client = "G$CLIENT",
    ClientHR = "G$CLIENT_HR",
    ClientStaff = "G$CLIENT_STAFF",
    ClientMirror = "G$CLIENT_MIRROR",
    ClientAdminViewOnly = 'G$CLIENT_VIEWONLY',
    ClientTimesheet = "G$CLIENT_TIMESHEET",
    ClientReport = "G$CLIENT_REPORT",
    Seeker = "G$SEEKER",
    Knight = "G$KNIGHT",
    KnightLeader = "G$KNIGHT_LEADER",
    // ProdOwner = "G$PRD_OWNER",
    // ProdAdmin = "G$PRD_ADMIN",
    // ProdStaff = "G$PRD_STAFF",
    // Koperasi = "G$KOPERASI",
    // KoperasiAdmin = "G$KOP_ADMIN",
    // KoperasiStaff = "G$KOP_STAFF",
}

export enum Status {
    Empty = "Empty",
    Approved = "Approved",
    Rejected = "Rejected",
    Pending = "Pending",
}